// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"141":"79f2a75a","449":"dbee82b4","451":"31da270e","469":"6d31de88","495":"8a2ac1d7","628":"06fae37a","657":"cd7de991","731":"53523203"}[chunkId] + ".js";
};